export default __webpack_public_path__ + "static/media/EBay_logo.979ee237.svg";